import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import EventsActions from 'app/actions/EventsActions';

const EventsSearchPageContainer = loadable(() =>
  import('app/components/events/EventsSearchPage/EventsSearchPageContainer')
);

export function EventsSearchPageRoute() {
  return <EventsSearchPageContainer />;
}

function getRouteData({ dispatch, query }) {
  return [dispatch(EventsActions.searchEvents(query))];
}

export default connectRoute(EventsSearchPageRoute, {
  getRouteData,
  debounceOptions: {
    wait: 100 // milliseconds
  }
});
